import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ArticleListWrapper = styled.section`
  margin: 0 ${layout.pageContent.gutter.rem};
`;
